import { useMemo } from "react";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";
import { mean } from "lodash";
import { useMenuData } from "../../../menu-provider/MenuDataProvider";
import { Paper, Typography } from "@mui/material";

export const TimeOfDaySalesChart = ({
  orders,
}: {
  orders: { createdAt: string; orderTotal: number }[];
}) => {
  const { currency } = useMenuData();

  const barChartData = useMemo(() => {
    const dayData = [];
    for (let i = 0; i <= 23; i++) {
      const hourOrders = orders.filter(
        (value) => new Date(value.createdAt).getHours() == i
      );

      const hourTotals = hourOrders.map((value) => value.orderTotal);
      dayData.push({ hour: i, orderTotals: hourTotals });
    }
    return dayData;
  }, [orders]);

  return (
    <Paper sx={{ padding: 1, marginBottom: 3 }}>
      <Typography sx={{ margin: 2 }} variant="h6">
        Average Sales by Hour
      </Typography>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={500}
          height={300}
          data={barChartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="hour" scale={"linear"} />
          <YAxis />
          <Tooltip
            labelFormatter={(label) => `${label}:00 to ${label}:59`}
            formatter={(value) => {
              const returnValue = isNaN(value as number)
                ? 0
                : (value as number).toFixed(2);
              return [`${currency}${returnValue}`, "Average sales"];
            }}
          />
          <Legend />
          <Bar
            dataKey={(value) => mean(value.orderTotals)}
            fill="#8884d8"
            label="Average"
            name="Sales by Hour"
          />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
};
